import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectStylesheet from 'react-jss';

import * as cssVariables from 'cssVariables';
import optimizely, { optimizelyFeatures } from 'api/optimizely';
import { VALID_COLORS, LABEL_TEXT } from './TileLabel.const';

function TileLabel({ classes, slug }) {
  const color = slug && optimizely.getFeatureVariable(optimizelyFeatures.TILE_LABELS, slug, null);
  if (!color || !VALID_COLORS.includes(color)) {
    return null;
  }
  return <span className={classNames(classes.label, classes[color])}>{LABEL_TEXT}</span>;
}

TileLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  slug: PropTypes.string,
};

TileLabel.defaultProps = {
  slug: null,
};

const styles = {
  label: {
    position: 'absolute',
    zIndex: 4,
    top: -6,
    left: -6,
    color: cssVariables.white,
    textTransform: 'uppercase',
    fontSize: cssVariables.fontSizes.small,
    fontWeight: cssVariables.fontWeights.bold,
    lineHeight: '30px',
    padding: '0 10px',
    borderRadius: 2,
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.1), 0 5px 10px 0 rgba(0,0,0,0.1)',
  },
  blue: {
    backgroundColor: cssVariables.blue500,
  },
  yellow: {
    backgroundColor: cssVariables.yellow500,
  },
  red: {
    backgroundColor: cssVariables.red500,
  },
};

export default injectStylesheet(styles)(TileLabel);
